module.exports = __webpack_public_path__ + "static/2front-guerilla-2-5d3447a37b1c8f3011a2144b9bd594c1.png";